<div [ngClass]="badgeClasses">
  <span *ngIf="showIcon" [className]="'freud-icon freud-icon-sm ' + icon"></span>
  <span *ngIf="showText">{{text}}</span>
</div>
